import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ExitSessionDialogProps {
  open: boolean;
  onContinue: () => void;
  onSaveAndExit: () => void;
}

export function ExitSessionDialog({
  open,
  onContinue,
  onSaveAndExit,
}: ExitSessionDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onContinue}>
      <DialogTitle>{t('exitDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('exitDialog.message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onContinue} color="primary">
          {t('exitDialog.continueRecording')}
        </Button>
        <Button onClick={onSaveAndExit} color="error" variant="contained">
          {t('exitDialog.saveAndEnd')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
